import { fetchJiraSyncConfig, saveIssueKeyMap } from '../../services/jiraSyncConfig';

/* Rattachements manuels ticket Jira → membre + brique, fusionnés dans la configuration de la
   synchro pour que les prochains imports les appliquent d'eux-mêmes. */
export default function jiraIssueKeyMapHandlers() {
  async function saveJiraIssueKeyMap(entries) {
    const newMappings = {};
    for (const { issueKey, user_id, brique_id } of entries) {
      if (issueKey && user_id && brique_id) newMappings[issueKey] = { user_id, brique_id };
    }
    if (!Object.keys(newMappings).length) return;
    const { data: conf } = await fetchJiraSyncConfig();
    await saveIssueKeyMap({ ...(conf?.issue_key_map || {}), ...newMappings });
  }

  return { saveJiraIssueKeyMap };
}
